export const ACCOUNT_TYPE_BUYER = 'buyer';
export const ACCOUNT_TYPE_SELLER = 'seller';
export const PLATFORM_EDI_EXTERNAL_SFTP = 'edi-sftp-external';
export const PLATFORM_EDI_SFTP = 'edi-sftp';

export const TEST_ORDER_FLAGGED_MESSAGE =
  'This is a test order, you must confirm the sync before you can proceed';

export const SHOPIFY_APP_STORE_URL =
  'https://apps.shopify.com/modern-dropship-by-carro?show_store_picker=1';

/** The widest mobile viewport: one below `ThemeBreakpoints.md` (768), where the sidebar shows. */
export const NAV_IS_MOBILE_MAX_WIDTH = 767;

/** The mobile menu's fixed header, which the page and its sticky bars sit below. */
export const MOBILE_HEADER_HEIGHT = 50;

export const MARKETPLACE_FILTERS_WIDTH = 230;
